import fetch from "auth/GenericFetchInterceptorV5";

const MagazziniService = {};

MagazziniService.addSource = function (body) {
    return fetch({
        url: `/api/storages`,
        method: "POST",
        data:body
    });
};

MagazziniService.getSources = function (documentId) {
    return fetch({
        url: `/api/storages?filters[company][documentId]=${documentId}`,
        method: "GET",
    });
};

MagazziniService.getSourcesAfter = function (documentId, updatedAtISO) {
    return fetch({
        url: `/api/storages?filters[company][documentId]=${documentId}&filters[updatedAt][$gt]=${updatedAtISO}`,
        method: "GET",
    });
};

// New method to get just the count of warehouses for a company
MagazziniService.getSourcesCount = function (documentId) {
    return fetch({
        url: `/api/storages?filters[company][documentId]=${documentId}&pagination[pageSize]=1&pagination[page]=1`,
        method: "GET",
    });
};

MagazziniService.getSource = function (SourceDocumentId) {
    return fetch({
        url: `/api/storages/${SourceDocumentId}?populate[lots][populate][0]=product&populate[warehouse_articles][populate][1]=lot`,
        method: "GET",
    });
};

MagazziniService.getDetailedSource = function (SourceDocumentId) {
    return fetch({
        url: `/api/storages/${SourceDocumentId}?populate[warehouse_articles][populate][lot][populate][product][populate]=supplier`,
        method: "GET",
    });
};

MagazziniService.updateStorage = function (SourceDocumentId, body) {
    return fetch({
        url: `/api/storages/${SourceDocumentId}`,
        method: "PUT",
        data: body
    });
};

MagazziniService.deleteStorage = function (SourceDocumentId) {
    return fetch({
        url: `/api/storages/${SourceDocumentId}`,
        method: "DELETE"
    });
};

MagazziniService.getCode = function () {
    return fetch({
        url: `/api/storage/next-cod`,
        method: "GET",
    });
};

export default MagazziniService;
